export const API_URL =
  process.env.REACT_APP_API_URL || 'https://jpoadev.aedicippa.com';
export const IMAGE_URL =
  process.env.REACT_APP_IMAGE_URL ||
  'https://jpoa-dev.s3.ap-east-1.amazonaws.com/original/';
export const SECURE_IMAGE_URL =
  process.env.REACT_APP_SECURE_IMAGE_URL ||
  'https://jpoadev.mypal.my/v1/file/secure/';
export const PAGE_SIZE = 20;
